const body = document.querySelector('body')
const header = document.querySelector('header')
const toggleMenu = document.querySelector('.toggleBurger')
const navigationDefault = document.querySelector('.navigationHeader')
const navList = document.querySelector('.menuList')
const navPoints = navigationDefault.querySelectorAll('a')

// Close Navigation
const closeNavigation = () => {
    toggleMenu.classList.remove('active')
    toggleMenu.setAttribute("aria-label", "Open menu")
    toggleMenu.setAttribute("aria-expanded", "false")
    navigationDefault.classList.remove('active')
    body.classList.remove('no-scroll')
    navigationDefault.setAttribute("aria-hidden", "true")
    navPoints.forEach(link => {
        link.setAttribute('tabindex', '-1')
    })
}

// Navigation ActiveState
const getState = (item) => {
    const pathnames = location.pathname.split('/').slice(1)
    const pathKey = item.getAttribute('data-name')
    const isActive = pathnames.includes(pathKey)

    if(isActive) {
        item.parentElement.classList.add('active')
        item.setAttribute('aria-current', 'page')
    }
}

// Change Order of mobile navigation-lists and Tabindex MainNavPpints
const responsiveChanges = () => {
    if(window.innerWidth < 1300) {
        navigationDefault.setAttribute('aria-hidden', 'true')
        navPoints.forEach(link => {
            link.setAttribute('tabindex', '-1')
        })
    }
    if(window.innerWidth >= 1300) {
        navigationDefault.setAttribute('aria-hidden', 'false')
        navPoints.forEach(link => {
            link.setAttribute('tabindex', '0')
        })
    }
}

// Execute Functions
responsiveChanges()

window.addEventListener('resize', () => {
    responsiveChanges()
});

navPoints.forEach(item => {
    getState(item);
    item.addEventListener('click', () => {
        closeNavigation()
    })
})

// Open/Close Navigation Mobile
toggleMenu.addEventListener('click', () => {
    toggleMenu.classList.toggle('active')
    navigationDefault.classList.toggle('active')
    body.classList.toggle('no-scroll')

    if(toggleMenu.classList.contains('active')) {
        const currentNavPoints = navigationDefault.querySelectorAll('a') 
        navigationDefault.setAttribute("aria-hidden", "false")
        toggleMenu.setAttribute("aria-label", "Close menu")
        toggleMenu.setAttribute("aria-expanded", "true")
        navPoints.forEach(link => {
            link.setAttribute('tabindex', '0')
        })
        currentNavPoints[0].focus()

        // Tab-Trap in Mobile Menu
        navigationDefault.addEventListener('keydown', (event) => {     
            const currentFirstNavPoint = currentNavPoints[0]
            const currentLastNavPoint = currentNavPoints[currentNavPoints.length - 1] 

            if (window.innerWidth < 1300 && event.key === 'Tab') {
                if (event.shiftKey && document.activeElement === currentFirstNavPoint) {
                    event.preventDefault()
                    toggleMenu.focus()
                } else if (!event.shiftKey && document.activeElement === currentLastNavPoint) {
                    event.preventDefault()
                    toggleMenu.focus()
                }
            }
        })
    }
    if(!toggleMenu.classList.contains('active')) {
        closeNavigation()
    }
})